export default {
    ACCEPTED_TRADE: 'Tinangap mo ang Trade.',
    ACCEPTED_TRADE_OTHER: 'Tinanggap na nang ibang player ang trade.',
    ALREADY_HAVE_PET: 'Meron ka nang Pet.',
    BLACK_POTION: 'Uminom ka nang Black Potion at nagsimulang sumama ang pakiramdam mo.',
    CANNOT_ADD_ITEMS_TRADE: 'Hindi ka pwedeng maka dagdag ng item sa Trade.',
    CANNOT_ATTACK_CHEATER: 'Ang player na yan ay isang cheater, wag mong atakihin yan',
    CANNOT_ATTACK_CHEATER_SELF: 'Paumanhin, hindi maaring maka atake ang mga Cheater',
    CANNOT_ATTACK_MOB: 'Hindi mo pwedeng atakihin ang nilalang na ito.',
    CANNOT_ATTACK_PET: 'BAWLIW KABA?! Nasisiraan kaba ng bait? bakit ka umaatake ng hayop?!',
    CANNOT_ATTACK_PREY: 'Hindi ka maaring umatake habang ikaw ang biktima.',
    CANNOT_ATTACK_TARGET: 'Hindi mo maaring atakihin ang salakayin na hindi mo target.',
    CANNOT_ATTACK_LEVEL_DIFF: 'Hindi mo maaring atakihin ang player na higit 30 levels sa iyo.',
    CANNOT_DO_THAT: 'Hindi mo magawa yan ngayon.',
    CANNOT_DROP_ITEM_DOOR:
        'Hindi mo pwedeng mabitawan ang item na ito habang ikaw ay nakatayo sa isang pinto.',
    CANNOT_PASS_DOOR: 'Di ka pwedeng makadaan sa pinto na ito.',
    CANNOT_GLOBAL_CHAT_SECONDS:
        'Kailangan mong mag hintay ng {{duration}} segundo bago maka gamit ng Global Chat.',
    CANNOT_GLOBAL_CHAT_MINUTES:
        'Kailangan mong mag hintay ng {{duration}} minuto bago maka gamit ng Global Chat.',
    CANNOT_GLOBAL_CHAT_JAIL: 'Hindi ka pwedeng makapag Global Chat habang ikaw ay nasa kulungan.',
    CANNOT_GLOBAL_CHAT_TUTORIAL:
        'Hindi ka pwedeng makapag Global chat habang ikaw ay nasa Tutorial.',
    CANNOT_PICK_UP_ITEM: 'ang item na ito at ma ari lamang kunin ni {{username}}.',
    CANNOT_TALK: 'Hindi ka makapagsalita ngayon',
    CANNOT_TRADE_ITEM: 'Hindi ma aring i-trade ang item na ito.',
    CANNOT_TRADE_CHEATER: 'Paumanhi pero bawal mag trade ang mga cheaters.',
    CANNOT_TRADE_CHEATER_OTHER: 'Manloloko ang player na yan, baka bebentahan ka ng droga nyan!',
    CANNOT_TRADE_ADMIN: 'Bilang isang admin, hindi mo maiimpluwensya ang ekonomiya ng Kaetram.',
    CANNOT_TRADE_ADMIN_OTHER:
        'Ang Player na to ay isang admin at hindi maaring makapag trade sakanya.',
    DONT_THINK_GO_IN: 'Sa tingin ko, dapat di pa ako papasok diyan.',
    ENTERED_LOBBY: 'Pumasok ka sa lobby ni {{name}}.',
    EXITED_LOBBY: 'Umalis ka sa lobby ni {{name}}.',
    IN_PVP_ZONE: 'Pumasok ka sa isang PvP zone!',
    INVALID_AMOUNT: 'Hindi wastong halaga ang nilagay mo.',
    DOOR_KEY_CRUMBLES: 'Ang susi ay gumuho at naging alikabok habang dumadaan ka sa pintuan',
    MINIMUM_PLAYERS_MINIGAME:
        'Dapat merong at least {{minimum}} na players upang makapag laro sa mini-game na ito.',
    NEED_COMBAT: 'Dapat ay nasa laban ka upang magamit ang abilidad na ito',
    NEED_WAIT_ABILIY:
        'Kailangan mo mag hintay ng {{duration}} segundo bago gamitin ang abilidad na ito.',
    NO_IDEA: 'Di ko alam kung ano ito.',
    NO_ARROWS: 'Kailangan mo ng arrow para makapag tira.',
    NO_ACHIEVEMENT_DOOR:
        'Kailangan mong kumpletohin ang {{achievement}} upang makapag daan sa pinto na ito.',
    NO_COMBAT_DOOR: 'Ang iyong combat level ay dapat at least {{level}} para makapasok.',
    NO_QUEST_DOOR:
        'Kailangan mong kumpletuhin ang quest na {{quest}} para makapasok sa pinto na ito.',
    NO_KEY_DOOR: 'You do not have the required key to pass through this door.',
    NO_SKILL_DOOR: 'Ang {{skill}} ay dapat atleast {{level}} para maka pasok.',
    NO_KNOWLEDGE_USE: 'Kulang ang kaalaman mo para gamitin ito.',
    NO_SPACE: 'Kulang ng espasyo ang iyong imbentaryo.',
    NO_SPACE_OTHER: 'Kulang sa espasyo ang imbentaryo ng ibang malalaro.',
    NO_SPACE_PET: 'Kulang ang espasyo ng iyong Pet Inventory.',
    NOT_IN_PVP_ZONE: 'Wala ka na sa PvP zone!',
    NOT_ONLINE: 'Player @aquamarine@{{username}}@crimson@ ay hindi online.',
    NOT_ENOUGH_MANA: 'Kulang ang mana mo para gamitin ang abilidad na ito.',
    PLEASE_MAKE_ROOM_REWARD: 'Mag bigay ng puwang sa iyong imbentaryo upang ma tanggap ang reward',
    POISONED: 'Nalason ka!',
    POISON_WORN_OFF: 'Nawala na ang lason.',
    PLEASE_REPORT_BUG: 'May error na naganap, i-report ito bilang isang bug.',
    FREEZE_IMMUNITY: 'Ikaw ay immune sa mga Freeze Effect hanggang {{duration}} segundo.',
    FREEZE_IMMUNITY_WORN_OFF: 'Nawala na ang immunity mo sa Freeze Effect.',
    FIRE_IMMUNITY: 'Ikaw ay immune sa mga Fire Effect hanggang {{duration}} segundo.',
    FIRE_IMMUNITY_WORN_OFF: 'Nawala na ang immunity mo sa Fire Effect.',
    FRIENDS_USERNAME_TOO_LONG: 'Ang username mo ay masyadong mahaba.',
    FRIENDS_ADD_SELF: `Makinig ka, alam ko ikaw ay nag-iisa at walang jowa pero di mo pwedeng i-add sarili mo.`,
    FRIENDS_ALREADY_ADDED: 'Ang player na ito ay nasa Friends List mo na.',
    FRIENDS_USER_DOES_NOT_EXIST: 'Walang player na merong ganon na username.',
    FRIENDS_NOT_IN_LIST: 'Ang player na to ay wala sa iyong Friends list.',
    PEOPLE_ONLINE: 'Merong {{population}} na manlalaro.',
    SKILL_LEVEL_UP: 'Tumaas ang level ng skill mo',
    SKILL_LEVEL_UP_DESC: 'Congratulations, si {{name}} ay naging {{level}}!',
    JAILED: 'Ikaw ay nasa kulungan hanggang {{duration}}.',
    MUTED: 'Ikaw ay naka-mute.',
    LOW_MANA: 'Mababa ang mana mo, ang iyong mga atake ay magiging mas mahina.',
    TRADE_REQUEST: 'Humihiling kang makipag trade kay {{username}}.',
    TRADE_REQUEST_OTHER: 'Si {{username}} ay humihiling na makipag trade sa iyo.',
    TRADE_EMPTY: `Yo, Bakit wala kayong pinagpalit?`,
    TRADE_COMPLETE: 'Salamat sa paggamit ng Trading System nang Kaetram!',
    WELCOME: 'Maligayang pagdating {{name}}!',
    WELCOME_BACK: 'Maligayang pag balik {{name}}!',
    WHY_GO_THERE: 'Teka lang, bakit ako pupunta diyan?'
} as const;
